import { render } from "./User.vue?vue&type=template&id=f298d9a6&scoped=true"
import script from "./User.vue?vue&type=script&lang=js"
export * from "./User.vue?vue&type=script&lang=js"

import "./User.vue?vue&type=style&index=0&id=f298d9a6&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-f298d9a6"

export default script